<template lang="pug">
    layout
        template(slot="title")

            // Title
            title-component(:title="$t('configuration.title')" type="h1")

        div
            v-tabs(v-model="tab")
                v-tab Markets
                v-tab Portfolio
                v-tab Data


            v-tabs-items(v-model="tab")
                v-tab-item
                    markets
                v-tab-item
                    portfolio
                v-tab-item
                    data-config
</template>

<script>
    import { Title } from '~components';
    import Markets from './Markets';
    import DataConfig from './DataConfig';
    import Portfolio from './Portfolio';
    import Layout from '../Layout';

    export default {
        components: {
            Layout,
            Markets,
            DataConfig,
            Portfolio,
            TitleComponent: Title,
        },
        data() {
            return {
                tab: null,
            };
        },
    };
</script>

<style lang="stylus" scoped></style>
